//Imports node_modules
import React from "react"

//Imports Css
import './TopBar.css'

//Imports Components
import BackButton from "./backButton/BackButton"
import NextButton from "./nextButton/NextButton"


//Layout de navegação na parte superior da aplicação
const TopBar = (params) => {

    //--- Variaveis

    //Variaveis locais

    let type = params.type ? params.type : ''
    let layout = params.layout ? params.layout : '1'

    //--- Fim variaveis 

    function renderLayout() {
        switch (layout) {
            case '1': return (
                <div className="containerNav">
                    <div className="fixedNav">
                        <BackButton
                            click={params.backbtnClick}
                            isDisabled={params.isDisabled ? params.isDisabled : false}
                            backText={params.backText ? params.backText : "Voltar"} voltar></BackButton>
                    </div>
                    <div className="flex-itemNav">
                        {renderSwitchBtn()}
                    </div>
                </div>
            )

            case '2': return (
                <div className="containerNav">
                    <div className="flex-itemNav">
                        {renderSwitchBtn()}
                    </div>
                    <div className="fixedNav" style={{width: '260px'}}>
                        <BackButton
                            click={params.backbtnClick}
                            isDisabled={params.isDisabled ? params.isDisabled : false}
                            backText={params.backText ? params.backText : "Voltar"} continuar></BackButton>
                    </div>
                </div>
            )
            default:
                break;
        }
    }

    function renderSwitchBtn() {
        switch (type) {
            case 'blue':
                return (<NextButton
                    isDisabled={params.isDisabled ? params.isDisabled : false}
                    click={params.nextBtnClick} blue nextText={params.texto ? params.texto : ""}   ></NextButton>);
            case 'green':
                return (<NextButton
                    isDisabled={params.isDisabled ? params.isDisabled : false}
                    click={params.nextBtnClick} green nextText={params.texto ? params.texto : ""}></NextButton>);
            case 'purple':
                return (<NextButton
                    isDisabled={params.isDisabled ? params.isDisabled : false}
                    click={params.nextBtnClick} purple nextText={params.texto ? params.texto : ""}></NextButton>);
            default:
                return (<NextButton
                    isDisabled={params.isDisabled ? params.isDisabled : false}
                    click={params.nextBtnClick} green nextText={params.texto ? params.texto : ""}></NextButton>);
        }
    }

    return (
        renderLayout()
    )
}

export default TopBar

